import { getDataFromLocalStorage } from "../util/localStorage";
import { resolveRole } from "../util/accessControl";

const useAuth = () => {
  const userInfo = getDataFromLocalStorage("userInfo") || {};

  const role = userInfo.tenantRole || resolveRole(userInfo.role) || "viewer";
  const roleLabel = Number(userInfo.role) === 0
    ? "Super Admin"
    : Number(userInfo.role) === 1
      ? "Account Admin"
      : role.replace(/_/g, " ");

  return {
    user: {
      ...userInfo,
      role,
      roleLabel,
      rawRole: userInfo.role,
      tenantId: userInfo.tenantId ? String(userInfo.tenantId) : null,
    },
  };
};

export default useAuth;
